
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  props: {
    model: {} as any,
  },
  data() {
    return {
      showSchemeFromVehicleBack: false,
      showSchemeCuts: false,
      showSchemeLevels: false,
    };
  },
  created() {
    const settings = (store as any).state.settings.settings;

    if (settings) {
      this.showSchemeFromVehicleBack = settings.showSchemeFromVehicleBack;
      this.showSchemeCuts = settings.showSchemeCuts;
      this.showSchemeLevels = settings.showSchemeLevels;
    }
  },
});
